import { useEffect, useState } from 'react';
import {
    FormVariant,
} from '~/src/context/client-request-form/client-request-form.types';

export const useBadgeHook = (currentVariant: FormVariant) => {
    const [showBadge, setShowBadge] = useState(false);

    useEffect(() => {
        if (currentVariant === 'selfEmployed') {
            setShowBadge(true);
        }
    }, [currentVariant]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (showBadge) {
                setShowBadge(false);
            }
        }, 3000);

        return () => {
            clearTimeout(timer);
        };
    }, [showBadge]);

    return showBadge;
};